import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsSankey from "highcharts/modules/sankey";
import styles from "./highcharts-sankey-chart-container.less";

highchartsSankey(Highcharts);

type HighchartsSankeyChartContainerProps = {
    options: Highcharts.Options
};

export const HighchartsSankeyChartContainer = (props: HighchartsSankeyChartContainerProps) => {
    const { options } = props;

    return (
        <div className={styles.highchartsSankeyChartContainer}>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};